function isLoggerEnabled() {
  try {
    if (process.env.NODE_ENV !== 'production') {
      return true
    }
    return localStorage.getItem('8S-debug') === 'true'
  } catch (ignore) {
    return false
  }
}

function logger(message, context) {
  const style = [
    'color: #333',
    'background: #fff',
    'font-size: 14px',
    'border: 2px solid #fff',
    'padding: 10px',
    'border-radius: 24px',
  ].join(';')

  if (isLoggerEnabled()) {
    console.debug(`%c👋 8SELECT: ${message}`, style, context)
  }
}

export default logger
